import { cn } from '@repo/utils';
import { formatMoney } from '@repo/utils';

interface MoneyProps {
  paise?: number;
  amount?: number;
  currency?: string;
  locale?: string;
  emphasis?: 'hero' | 'inline' | 'table';
  negative?: boolean;
  className?: string;
}

export function Money({
  paise,
  amount,
  currency = 'INR',
  locale = 'en-IN',
  emphasis = 'inline',
  negative,
  className,
}: MoneyProps) {
  const finalPaise = paise ?? (amount !== undefined ? Math.round(amount * 100) : 0);
  const isNegative = negative ?? finalPaise < 0;
  const valueToFormat = negative && finalPaise > 0 ? -finalPaise : finalPaise;
  const formatted = formatMoney(valueToFormat, { currency, locale, signDisplay: 'auto' });

  return (
    <span
      className={cn(
        'tnum',
        isNegative ? 'text-danger-text' : undefined,
        emphasis === 'hero' && 'font-semibold text-4xl leading-tight',
        emphasis === 'table' && 'text-right block text-sm',
        className,
      )}
    >
      {formatted}
    </span>
  );
}
